import { formatTag, getPostsForTag, PostType } from '@space-cow-media/wp-components'

import Container from '@/components/Container/Container'
import Main from '@/components/Main/Main'
import SimpleHeader from '@/components/SimpleHeader/SimpleHeader'
import ArticleSearch from '@/components/Wordpress/ArticleSearch/ArticleSearch'
import ArticleTypePage from '@/components/Wordpress/ArticleTypePage/ArticleTypePage'
import { ARTICLES_REVALIDATE_INTERVAL } from '@/utils/constants'

export type Props = {
  enableAdhesion: boolean
  pageCount: number
  pageNum: number
  posts: PostType[]
  tag: string
}

const ArticlesTagSubPage = ({ enableAdhesion, pageCount, pageNum, posts, tag }: Props) => (
  <Main>
    <Container>
      <div className='mx-3'>
        <SimpleHeader className='d-flex gap-3 mb-3'>
          {formatTag(tag)}
          <ArticleSearch />
        </SimpleHeader>
        <ArticleTypePage pageCount={pageCount} posts={posts} pageNum={pageNum} path={`tag/${tag}`} />
      </div>
      {enableAdhesion && <div className='mvHomeAdhesion' />}
    </Container>
  </Main>
)

export const getStaticPaths = async () => ({
  paths: [],
  fallback: 'blocking',
})

export const getStaticProps = async ({ params: { page, tag } }: { params: { page?: string; tag: string } }) => {
  if (page === '1') {
    return {
      redirect: {
        destination: `/articles/tag/${tag}`,
        permanent: true,
      },
    }
  } else if (page === undefined) {
    page = '1'
  }

  const pageNum = parseInt(page as string, 10)
  const { pageCount, posts } = await getPostsForTag({ categoryId: 4, pageNum, tag })

  return {
    props: {
      enableAdhesion: true,
      pageCount,
      pageNum,
      posts,
      tag,
    },
    revalidate: ARTICLES_REVALIDATE_INTERVAL,
  }
}

export default ArticlesTagSubPage
